import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp, Target, Brain } from "lucide-react";
import ModelTraining from "@/components/forecast/ModelTraining";
import ForecastVisualization from "@/components/forecast/ForecastVisualization";
import BuySignals from "@/components/forecast/BuySignals";
import Layout from "@/components/layout/Layout";

export default function PriceForecast() {
  const [activeTab, setActiveTab] = useState("forecasts");

  return (
    <Layout>
      <div className="container mx-auto p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold">Price Forecasting</h1>
            <p className="text-muted-foreground mt-1">
              ML-powered price predictions and buying recommendations
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Active Models</CardTitle>
              <Brain className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">--</div>
              <p className="text-xs text-muted-foreground">
                Trained prediction models
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Forecasts</CardTitle>
              <TrendingUp className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">--</div>
              <p className="text-xs text-muted-foreground">
                Price predictions available
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Buy Signals</CardTitle>
              <Target className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">--</div>
              <p className="text-xs text-muted-foreground">
                Active buying opportunities
              </p>
            </CardContent>
          </Card>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="forecasts">Forecasts</TabsTrigger>
            <TabsTrigger value="signals">Buy Signals</TabsTrigger>
            <TabsTrigger value="training">Model Training</TabsTrigger>
          </TabsList>

          <TabsContent value="forecasts" className="space-y-4">
            <ForecastVisualization />
          </TabsContent>

          <TabsContent value="signals" className="space-y-4">
            <BuySignals />
          </TabsContent>

          <TabsContent value="training" className="space-y-4">
            <ModelTraining />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
